import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { CommercialIcon } from 'framework/ui/mui-builder';
import type { ObjectDetailsHeaderAction } from 'framework/ViewTypes/contentLayout';
import type { ActiveProcessesItem } from 'framework/ViewTypes/embeddable';
import type { ApplicationDetails, ApplicationStageActions } from '../../shared/types';

export const getCalculatePercentileAction = (actions: ApplicationStageActions): ObjectDetailsHeaderAction => ({
  id: 'calculate-percentile',
  label: 'Calculate percentile',
  tooltip: 'Calculate percentile',
  icon: <CommercialIcon sx={{ stroke: 'currentColor' }} />,
  variant: 'outlined',
  onClick: actions.calculatePercentile,
});

export const getRejectApplicationAction = (actions: ApplicationStageActions): ObjectDetailsHeaderAction => ({
  id: 'reject-application',
  label: 'Reject application',
  tooltip: 'Reject application',
  icon: <BlockOutlinedIcon />,
  variant: 'outlined',
  color: 'error',
  onClick: actions.startRejection,
});

export const getEditApplicationAction = (actions: ApplicationStageActions): ObjectDetailsHeaderAction => ({
  id: 'edit-application',
  label: 'Edit application',
  tooltip: 'Edit application',
  icon: <EditOutlinedIcon />,
  variant: 'outlined',
  onClick: actions.editApplication,
});

export const hasRejectionDecision = ({ rejectionReason, withdrawalReason }: ApplicationDetails) =>
  Boolean(rejectionReason || withdrawalReason);

export const getRejectCandidateProcess = (actions: ApplicationStageActions): ActiveProcessesItem => ({
  id: 'reject-candidate',
  title: 'Reject candidate',
  action: {
    id: 'reject-candidate',
    label: 'Reject candidate',
    variant: 'contained',
    onClick: actions.startRejection,
  },
});
